import React from 'react'

function GoogleTranslator() {
  return (
     <div className="flex flex-col items-center bg-white/90 backdrop-blur-md border border-gray-300 shadow-md rounded-lg px-3 py-2">
            <h4 className="text-[11px] font-semibold text-gray-700 mb-1">
              Language
            </h4>
            <div id="google_translate_element" className="text-[12px]" />
          </div>
  )
}

export default GoogleTranslator